// RolesEnum.ts
export enum RePlanRole {
  khtd_cap_nhat_chien_dich = 'KHTD_CAP_NHAT_CHIEN_DICH',
  khtd_chia_chi_tieu = 'KHTD_CHIA_CHI_TIEU',
  khtd_tao_chien_dich = 'KHTD_TAO_CHIEN_DICH',
  khtd_xem_danh_sach = 'KHTD_XEM_DANH_SACH',
  khtd_xem_data = 'KHTD_XEM_DATA',
  khtd_xem_data_xoa = 'KHTD_XEM_DATA_XOA',
  khtd_xem_lich_su = 'KHTD_XEM_LICH_SU',
  khtd_xem_tong_quan = 'KHTD_XEM_TONG_QUAN',
}
